import 'babel-polyfill'
import ReactDOM from 'react-dom'
import React from 'react'
import initlaizeMainPage from '../initializers/main_page'

import { sharedData } from '../models/shared_data'

let runInitializers = function() {
  sharedData.initialize()
  initlaizeMainPage()
}

// import { components as sessions_components } from '../components/sessions/components';
// import { components as common_components } from '../components/common/components';
// import { components as filter_components } from '../components/items_filter/components';
// import { components as cart_components } from '../components/cart/components';
// import { components as profile_components } from '../components/profile/components';
import profile_components from './profile/components';
import shared_components from './shared/components';
import cart_component from './cart/components';

let components = {
  ...profile_components,
  ...shared_components,
  ...cart_component
}

import cartData from './cart/models/cart.js';
// import userData from './common/models/user.js';

function initDatasources() {
    cartData.initFromData()
    // userData.initFromData()
}


let init_component = function(type, params, node) {
  // try {
    ReactDOM.render(
      React.createElement(components[type], params),
      node
    )
  // } catch(e) {

  // }
}

document.addEventListener('DOMContentLoaded', () => {
  runInitializers()
  initDatasources()

  let nodes = document.querySelectorAll("[data-react]")
  for(let node of nodes) {
    let component_name = node.getAttribute('data-react')
    // console.log(component_name)
    let params = {}
    try {
       params = JSON.parse(node.getAttribute('data-params'))
    } catch(e) {
      // console.log(component_name)
    }

    init_component(
      component_name,
      {params: params},
      node
    )
  }
})



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/initializer.js